"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var theme_1 = require("./theme");
var colors_1 = require("./utils/colors");
var Badge = function (props) {
    var secondaryThemeColor = (0, colors_1.useSecondaryThemeColor)();
    return react_1.default.createElement(StyledBadge, __assign({ secondaryThemeColor: secondaryThemeColor }, props));
};
exports.Badge = Badge;
var StyledBadge = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 32px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  text-transform: uppercase;\n  text-align: center;\n  margin-left: ", ";\n\n  /* subtract 0.5px to right margin to compensate for letter-spacing */\n  padding: 1px 5.5px 1px 6px;\n  letter-spacing: 0.5px;\n"], ["\n  display: inline-block;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 32px;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  text-transform: uppercase;\n  text-align: center;\n  margin-left: ", ";\n\n  /* subtract 0.5px to right margin to compensate for letter-spacing */\n  padding: 1px 5.5px 1px 6px;\n  letter-spacing: 0.5px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.primary;
}, function (_a) {
    var secondaryThemeColor = _a.secondaryThemeColor;
    return secondaryThemeColor;
}, theme_1.theme.space.xsmall);
var templateObject_1;
